import React from "react";
import { useState, useEffect } from "react";
import { useGlobalContext } from "../../context";
import api from "../../api";
import UserSideNav from "../components/UserSideNav";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import userDashLinks from "./userDashLinks";
import { BiSolidWallet } from "react-icons/bi";
import ReactDataTable from "../components/ReactDataTable";

const UserTransactions = () => {
  //universal variables
  const { allUserMongoData, allUserTrade, allUserDep, allUserWithdraw } =
    useGlobalContext();

  //user side nav------------------------------
  const [navActive, updateNavActive] = useState(null);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const clearSess = async () => {
    try {
      await api.post("/api/logout");
    } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => {
    updateNavActive(false);
  };

  //table----------------------------------------
  const [sortedData, setSortedData] = useState([]);

  useEffect(() => {
    const mappedTradeData = allUserTrade.map((trade) => ({
      date: trade.tradedate,
      type: "XTrading",
      amount: trade.tradeamount,
      receiver: "XTrading",
      status: trade.tradestatus,
    }));

    const mappedDepData = allUserDep.map((dep) => ({
      date: dep.date,
      type: dep.deptype,
      amount: dep.depamnt,
      receiver: "Self Deposit",
      status: "Completed",
    }));

    const mappedWithdrawData = allUserWithdraw.map((withdraw) => ({
      date: withdraw.withdrawdate,
      type: withdraw.withdrawtype + " Transfer",
      amount: withdraw.withdrawamount,
      receiver: withdraw.receiverdetails,
      status: withdraw.withdrawstatus,
    }));

    const combinedData = [
      ...mappedTradeData,
      ...mappedDepData,
      ...mappedWithdrawData,
    ];
    const sortedData = combinedData.sort(
      (a, b) => new Date(b.date) - new Date(a.date),
    );

    setSortedData(sortedData);
  }, [allUserTrade, allUserDep, allUserWithdraw]);

  const columns = [
    {
      name: "Date",
      selector: (row) => row.date,
      cell: (row) => (
        <div style={{ whiteSpace: "nowrap" }}>
          {new Date(row.date).toLocaleDateString()}
        </div>
      ),
    },
    {
      name: "Transaction Type",
      selector: (row) => row.type,
      cell: (row) => <div style={{ whiteSpace: "nowrap" }}>{row.type}</div>,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      cell: (row) => {
        const amountNumber = parseFloat(row.amount); // Convert to number

        return (
          <div style={{ whiteSpace: "nowrap", letterSpacing: "0.60px" }}>
            ${amountNumber.toLocaleString()}
          </div>
        );
      },
    },
    {
      name: "Receiver",
      selector: (row) => row.receiver,
      cell: (row) => <div style={{ whiteSpace: "normal" }}>{row.receiver}</div>,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <div
          style={{
            whiteSpace: "nowrap", // Prevent line breaks
            backgroundColor:
              row.status === "Pending"
                ? "#FFBF00"
                : row.status === "Declined"
                  ? "#cc0000"
                  : "#32CD32", // Lime Green for Completed, Amber for others
            padding: "1.0rem",
            color: "white",
            border: "10px inherit solid",
            borderRadius: "3px",
            height: "30px",
            minWidth: "104.8px",
            textAlign: "center",
            display: "flex",
            justifyContent: "center", // Center horizontally
            alignItems: "center", // Center vertically
            fontSize: "12px",
          }}
        >
          {row.status}
        </div>
      ),
    },
  ];

  return (
    <div className="absolute overflow-hidden w-full min-h-full text-white bg-black">
      <UserSideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={
          navActive ? `translate-x-[0px]` : `translate-x-[-500px]`
        }
        clearSess={clearSess}
        backgroundColor="bg-black"
        arrowCoLor="text-white"
        iconBorderColor="border-white"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={userDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1] " />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full p-4 overflow-hidden mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* <!-- ham and notification header --> */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            {/* <!-- hamburger menu --> */}
            <button
              onClick={() => updateNavActive(true)}
              className="relative xl:hidden"
            >
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>

            {/* <!-- user balance--> */}
            <div className="relative flex space-x-2">
              <div className="relative flex justify-center items-center space-x-2 min-h-[38px] py-2 px-4 bg-[#181C26] border border-[#1f2535] rounded-lg transition-all ease-in duration-200 hover:border-[#473ECD]">
                <BiSolidWallet className="text-[14px] text-[#A9ABAD]" />
                <p className="text-[12px] text-[#A9ABAD]">
                  $
                  {allUserMongoData && allUserMongoData.balance
                    ? allUserMongoData.balance.toLocaleString()
                    : "0"}
                </p>
              </div>
            </div>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">
            Transaction History
          </h3>
          <p className="text-[#A9ABAD] text-[14px]">
            A record of all your trades, deposits, and transfers.
          </p>
        </div>

        <div className="relative w-full">
          <ReactDataTable columns={columns} data={sortedData} />
        </div>
      </div>
    </div>
  );
};

export default UserTransactions;
